import React from 'react';

import {
  ExclamationTriangleSolidIcon,
  InfoCircleSolidIcon,
  TimesCircleSolidIcon
} from '../../shared/icons/icons';

import './message.scss';

//TODO Need to update isWarning and isInfo into a type enum prop
interface MessageProps {
  className?: string;
  isAlignCenter?: boolean;
  isError?: boolean;
  isInfo?: boolean;
  isLight?: Boolean;
  isWarning?: Boolean;
  message?: React.ReactNode;
}

function Message(props: MessageProps) {
  const {
    className,
    isAlignCenter,
    isError,
    isInfo,
    isLight,
    isWarning,
    message
  } = props;

  let styleName = 'message';
  if (isError) styleName = 'error';
  if (isWarning) styleName = 'warning';
  if (isInfo) styleName = 'info';
  if (isAlignCenter) styleName += ' center';
  if (isLight) styleName += ' light';

  return (
    <div className={`message ${className || ''}`} styleName={styleName}>
      {isError && (
        <TimesCircleSolidIcon
          className="message__error-icon"
          styleName={isLight ? 'light-icon' : 'icon'}
        />
      )}

      {isWarning && (
        <ExclamationTriangleSolidIcon
          className="message__warning-icon"
          styleName={isLight ? 'light-icon' : 'icon'}
        />
      )}

      {isInfo && (
        <InfoCircleSolidIcon className="message__info-icon" styleName="icon" />
      )}
      <div className="message__message">{message}</div>
    </div>
  );
}

export default Message;
